import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { GET_INTERVIEWS } from "graphql/queries";
import { colors } from "style";
import { useLinks, useVideoPresentation } from "hooks";
import { Grid } from "components/Containers";
import { INTERVIEW_TYPES } from "constants/index";
import { DataTableProvider } from "components/DataTable";
import { PAGINATION_TYPE } from "components/Pagination";
import { ActionButton } from "components/Buttons";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import { PrimaryLink } from "components/Links";
import InterviewEditModal from "./InterviewEditModal";
import Tags from "components/Tags";

/**
 * Interviews List
 */
const InterviewsList = (props) => {
  const [showEditForm, setShowEditForm] = useState(false);
  const [selectedInterview, setSelectedInterview] = useState();

  const { handleDuplicateInterview, duplicatingInterview, handleRemoveInterview, removingInterview } =
    useVideoPresentation();

  const links = useLinks();
  const paginationProps = {
    paginationType: PAGINATION_TYPE.classic,
  };

  const handleRowEdit = (item) => {
    setSelectedInterview(item);
    setShowEditForm(true);
  };

  const rowOptions = (item) => [
    {
      label: <FormattedMessage id="Global.Edit" />,
      icon: ICON_TYPE.edit,
      onClick: () => handleRowEdit(item),
    },
    {
      label: <FormattedMessage id="Global.Duplicate" />,
      icon: ICON_TYPE.duplicate,
      onClick: () =>
        handleDuplicateInterview({
          interviewId: item.id,
          newName: `${item.name} (Copy)`,
          published: false,
          refetchQueries: [GET_INTERVIEWS],
        }),
      disabled: duplicatingInterview,
    },
    {
      label: <FormattedMessage id="Global.Delete" />,
      icon: ICON_TYPE.trash,
      onClick: () =>
        handleRemoveInterview({
          id: item.id,
          refetchQueries: [GET_INTERVIEWS],
        }),
      disabled: removingInterview,
    },
  ];

  return (
    <>
      <Grid>
        <Grid.col start={1} end={13}>
          <DataTableProvider
            queryName={GET_INTERVIEWS}
            variables={{
              filters: {
                type: INTERVIEW_TYPES.platform,
                withoutMissionRole: true,
                published: false,
              },
            }}
            rowOptions={rowOptions}
            keyName="interviews"
            columnData={COLUMNS(links)}
            {...paginationProps}
            {...props}
          />
        </Grid.col>
      </Grid>
      <InterviewEditModal interview={selectedInterview} show={showEditForm} onClose={() => setShowEditForm(false)} />
    </>
  );
};

const COLUMNS = (links) => [
  {
    label: <FormattedMessage id="Interviews.InterviewList.ColumnTitle" />,
    cell: (item) => item.name,
  },
  {
    label: <FormattedMessage id="Interviews.InterviewList.ColumnPublished" />,
    cell: (item) => <FormattedMessage id={`Global.${item.published ? "Yes" : "No"}`} />,
  },
  {
    label: <FormattedMessage id="Interviews.InterviewList.ColumnQuestionsCount" />,
    cell: (item) => item.questions?.length || 0,
  },
  {
    label: <FormattedMessage id="Interviews.InterviewList.ColumnCategories" />,
    cell: (item) => <Tags data={item.categories} />,
  },
  {
    cell: (item) => (
      <PrimaryLink to={links.settings_video_presentation(item.uuid)} routerEnabled>
        <ActionButton>
          <Icon type={ICON_TYPE.eye} size={ICON_SIZE.large} color={colors.purpleRainBase} />
        </ActionButton>
      </PrimaryLink>
    ),
  },
];

export default InterviewsList;
